import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { buildLoginUrl } from '../../utils/returnUrl'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: '#0f0c0a', color: '#e8dcc0'
      }}>
        Restoring session...
      </div>
    )
  }

  if (!user) {
    // returnUrl in the query string AND `from` in router state carry the same
    // intent. The query param is what survives a full page load — the Google
    // sign-in round trip, or the customer opening the link in a new tab — so it
    // is the primary; the state is kept for the existing forms that read it.
    return (
      <Navigate
        to={buildLoginUrl(location.pathname + location.search)}
        state={{ from: location }}
        replace
      />
    )
  }

  return <>{children}</>
}
